import { render, staticRenderFns } from "./MyTowerCard.vue?vue&type=template&id=3db32d5d&scoped=true&"
import script from "./MyTowerCard.vue?vue&type=script&lang=js&"
export * from "./MyTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MyTowerCard.vue?vue&type=style&index=0&id=3db32d5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db32d5d",
  null
  
)

export default component.exports